export const SET_MESSAGE = 'SET_MESSAGE'
export const INIT_USER = 'INIT_USER'
export const UPDATE_BOOKING = 'UPDATE_BOOKING'
export const CLEAR_BOOKING = 'CLEAR_BOOKING'
export const SET_LOADING = 'SET_LOADING'
export const UPDATE_REDEEM = 'UPDATE_REDEEM'
export const SET_CATEGORY = 'SET_CATEGORY'
export const SET_GROUP = 'SET_GROUP'

export const setMessage = (message) => {
  return {
    type: SET_MESSAGE,
    message
  }
}

export const initUser = (user) => {
  return {
    type: INIT_USER,
    user
  }
}

export const updateBooking = (booking) => {
  return {
    type: UPDATE_BOOKING,
    booking
  }
}

export const updateRedeem = (redeem) => {
  return {
    type: UPDATE_REDEEM,
    redeem
  }
}

export const clearBooking = () => {
  return {
    type: CLEAR_BOOKING,
  }
}

export const openLoading = (isLoading, loaderType = 'processing') => {
  return {
    type: SET_LOADING,
    isLoading,
    loaderType
  }
}

export const setCategory = (category = []) => {
  return {
    type: SET_CATEGORY,
    category,
  }
}

export const setGroupInfo = group => {
  return {
    type: SET_GROUP,
    group,
  }
}
